import mifosRepository, {MifosRepository} from "./MifosRepository";
import qs from "qs";

const usersResource = "/users";
const userdetailsResource = "/userdetails";

export default {
  getUserWithUserId(userId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${usersResource}/${userId}`);
  },

  getUserWithAccessToken(accessToken) {
    const queryData = {access_token: accessToken};
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(
        `${userdetailsResource}?${qs.stringify(queryData)}`
    );
  },

  updatePassword(userId, password, repeatPassword) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.put(
        `${usersResource}/${userId}`,
        {password: password, repeatPassword: repeatPassword}
    );
  },
}
